import { render } from "./MyCaptcha.vue?vue&type=template&id=4532051b"
import script from "./MyCaptcha.vue?vue&type=script&lang=js"
export * from "./MyCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue_referralcode\\referral_code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__